export default __webpack_public_path__ + "static/media/error-icon.e106ea18.svg";